<template>
    <section class="card-product-informations">
        <h2 v-if="customTitleCode" v-html="translate(customTitleCode)"/>
        <h2 v-else-if="data.title" v-html="translate(data.title)"/>

        <div v-if="data.values" class="elements-container">

            <div v-for="element in parsedData()" class="element accessory-element" v-if="!element.isDisabled">

                <template v-if="element.variable !== undefined">


                    <span class="title" v-html="getVariable(element.title).variableTranslation"/>

                    <template v-if="!isEditable">
                        <span v-if="element.title" class="value"
                              v-html="getVariableDefaultValue(element.title)"/>
                    </template>

                    <offer_editable_property_value
                            v-else
                            :initialData="getVariable(element.title).variableValues"
                            :defaultKey="getVariable(element.title).variableDefaultKey"
                            :elementKey="element.title"/>

                </template>
                <template v-if="element.variable === undefined">
                    <span v-if="element.title && element.additionalTitle" class="title" v-html="translate(element.title)+' ('+element.additionalTitle+' V)'"/>
                    <span v-else-if="element.title" class="title" v-html="translate(element.title)+((element.title == 'minimum_frequency_on_the_inverter' || element.title == 'minimum_amount_of_air_at_the_minimum_frequency') && comments == true ? '*' : '')"/>
                    <span v-if="element.value && element.translation" class="value"
                          v-html="translate(element.value)"/>
                    <span v-else-if="element.value && element.title != 'weight'" class="value" v-html="element.value"/>
                    <!-- NVS-178 -->
                    <span class="value one-line" v-if="element.title == 'weight'">
                        <span v-if="!weight_edit || !isAdmin" v-html="element.value" @click="weight_edit= true"/>
                        <input type="text" @blur="weight_edit = false" v-else class="edit-input" v-model="element.value">
                    </span>
                            
                    <div v-if="element.values">
                        <div v-for="sub_element in element.values" class="sub_element" v-if="sub_element.isActive">
                            <span :style="{'visibility':(sub_element.isActive?'':'hidden')}" class="icon-ok"/>
                            <span class="value" v-html="translate(sub_element.title)"/>
                        </div>
                    </div>

                </template>
            </div>
        </div>

        <!-- NVS-142 -->
        <div class="comments" v-if="comments">
            <div v-if="data.values.hasOwnProperty('minimum_frequency_on_the_inverter')" class="minimum_frequency_on_the_inverter hide-in-result-form">* {{ translate('minimum_frequency_on_the_inverter') }} - {{ translate('minimum_frequency_on_the_inverter_hint') }}</div>
            <div v-if="data.values.hasOwnProperty('minimum_amount_of_air_at_the_minimum_frequency')" class="minimum_amount_of_air hide-in-result-form">* {{ translate('minimum_amount_of_air_at_the_minimum_frequency') }} - {{ translate('minimum_amount_of_air_at_the_minimum_frequency_hint') }}</div>
        </div>
    </section>
</template>

<script>
    import Offer_editable_property_value from "../offers/offer_editable_property_value";

    export default {
        name: "customListcomponent",
        components: {Offer_editable_property_value},
        props: ['data', 'custom-title-code', 'comments'],
        data() {
            return {
                weight_edit: false,
            }
        },
        methods: {
            parsedData() {
                // NVS-50 Jeżeli częstotliwość sieci jest inna niż częstotliwość pracy to wyświetla TAK mimo wyboru NIE
                let modifiedData = this.data.values
                let net_f = (this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[1].active) ? 60 : 50
                if (this.$store.state.workPointParameters.elements.work_frequency.value != net_f && modifiedData.hasOwnProperty('work_on_the_inverter')) 
                    modifiedData.work_on_the_inverter.value = "yes"
                // NVS-147
                if (modifiedData.hasOwnProperty('work_on_the_inverter')) 
                    modifiedData.work_on_the_inverter.title = 'inverter_in_selection'
                return modifiedData
            },
            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            getVariable(code) {
                let arg = {
                    type: 'getVariable',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);
                if (arg.out === '' || null) {
                    return {variableTranslation: code, variableDefaultKey: 0, variableValues: []};
                }
                return arg.out;
            },
        },

        computed: {
            isEditable() {
                if(this.$store.getters.getUserRole !== 'admin') return false;
                return this.$store.getters.isOfferEditable;
            },

            isAdmin() {
                return this.$store.getters.getUserRole == 'admin'
            },

            getVariableDefaultValue() {
                return function (code) {
                    if (this.$store.state.productCard.custom.variables.hasOwnProperty(code)) {
                        let data = this.getVariable(code);
                        let value = data.variableValues.find(x => x.code === this.$store.state.productCard.custom.variables[code]);
                        if (value !== undefined) {
                            return value.value;
                        }
                    }
                    return this.$store.getters.getVariableDefaultValue(code);

                }
            },
        },
    }
</script>